import styled from 'styled-components';
import colors from '../../../config/colors';

const SubHeading = styled.div`
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Gilroy-Medium';
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    position: relative;
  }

  h2 {
    font-size: 28px;
    line-height: 38px;
    font-family: 'Gilroy-Medium';
    font-weight: 500;
    color: ${colors.BLACK_COLOR};
    margin-right: 6px;
  }

  ul {
    padding: 0;
    margin: 0 0 0 auto;
    list-style: none;
    display: flex;
    align-items: center;
    max-width: 100%;

    @media (max-width: 768px) {
      flex: 0 0 100%;
      // margin-top: 10px;
    }

    @media (max-width: 576px) {
      display: block;
    }

    li {
      font-size: 16px;
      color: ${colors.TEXT_GRAY};
      margin-left: 12px;
      display: flex;
      align-items: center;

      &:first-child {
        @media (max-width: 768px) {
          margin-left: 0;
        }
      }

      @media (max-width: 768px) {
        display: block;
        width: 100%;
      }

      @media (max-width: 576px) {
        margin: 0 0 10px;
      }

      span {
        font-size: 14px;
        // margin-right: 10px;
        color: ${colors.TEXT_GRAY};
      }
    }
  }

  > div {
    display: flex;
    align-items: center;
    margin-left: auto;

    a, button {
      margin-left: 30px;
      color: ${colors.PURPLE_COLOR};
      font-weight: 700;
      display: flex;
      align-items: center;

      @media (max-width: 768px) {
        margin-left: 10px;
      }

      &:hover {
        color: ${colors.TEXT_BLACK};

        svg {
          fill: ${colors.TEXT_BLACK};
        }
      }

      svg, img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
        fill: ${colors.PURPLE_COLOR};
        transition: fill 100ms ease-in-out;
      }
    }
  }

  label {
    margin-left: auto;
  }
`;

export default SubHeading;
